import { ColDef } from 'ag-grid-community';

export class GridColDefsSeguridadCentros{

  public columnDefs: ColDef[] = [
    { headerName: "", field: "", sortable: true,  headerClass: "header", autoHeight: true, checkboxSelection: true, width: 20,
    },
    { headerName: "Empresa", field: "nombreEmpresa", sortable: true, filter: true, headerClass: "header", wrapText: true, autoHeight: true, width: 240, sort: 'asc', sortIndex: 0,
            comparator: (valueA, valueB, nodeA, nodeB) => {
        const a = Number(nodeA.data.codigoEmpresa);
        const b = Number(nodeB.data.codigoEmpresa);
        return a - b;
      },
      cellRenderer: params => {
        return `${params.data.codigoEmpresa} - ${params.data.nombreEmpresa}`
      }
    },
    { headerName: "Centro", field: "nombreCentro", sortable: true, filter: true, headerClass: "header", wrapText: true, autoHeight: true, width: 240, sort: 'asc', sortIndex: 1,
      comparator: (valueA, valueB, nodeA, nodeB) => {
        const a = Number(nodeA.data.codigoCentro);
        const b = Number(nodeB.data.codigoCentro);
        return a - b;
      },
      cellRenderer: params => {
        return `${params.data.codigoCentro} - ${params.data.nombreCentro}`
      }
    }
  ]
}
